import React from 'react'
import dynamic from 'next/dynamic'
import { LoadingSpinner } from 'components/feedback/loading/loading-spinner'
import 'quill/dist/quill.snow.css'

const QuillEditor = dynamic(() => import('react-quill-new'), {
  ssr: false,
  loading: () => <LoadingSpinner />,
})

export const quillEditorStyle = {
  '.ql-editor': {
    fontFamily: `'Lato', sans-serif`,
    '& ul': {
      listStyleType: 'disc',
    },
    '& ol': {
      listStyleType: 'decimal',
    },
    '& li': {
      listStylePosition: 'inside',
      listStyleType: 'inherit',
    },
    '& h1, & h2, & h3': {
      fontWeight: 'bold',
    },
    '& h1': {
      fontSize: '2em', // Specify desired font size
    },
    '& h2': {
      fontSize: '1.5em', // Specify desired font size
    },
    '& h3': {
      fontSize: '1.17em', // Specify desired font size
    },
    '& blockquote': {
      marginBottom: '5px',
      marginTop: '5px',
      paddingLeft: '16px',
      borderLeft: '4px solid #ccc',
    },
  },
}

type TextEditorProps = {
  defaultValue?: string
  onChange: (value: string) => void
}
const TextEditor = ({ defaultValue, onChange }: TextEditorProps) => {
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      [{ align: [] }],
      [{ color: [] }],
      ['clean'],
    ],
  }

  const quillFormats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'link',
    'image',
    'align',
    'color',
    'code-block',
  ]

  return (
    <QuillEditor
      defaultValue={defaultValue}
      onChange={onChange}
      modules={quillModules}
      formats={quillFormats}
      theme="snow"
    />
  )
}

export default TextEditor
